var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSendingback30 = function SvgAIconSendingback30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3077 18.9231H27C28.1046 18.9231 29 18.0276 29 16.9231V5C29 3.89543 28.1046 3 27 3H8C6.89543 3 6 3.89543 6 5V10.6154",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0479 11.5302L28.1153 18.4808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3238 3.52158L19.0232 13.1815C18.9312 13.277 18.8314 13.3654 18.7166 13.4317C17.9645 13.8665 17.0365 13.8665 16.2844 13.4317C16.1697 13.3654 16.0698 13.277 15.9779 13.1815L6.67676 3.52158",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 28C11.866 28 15 24.866 15 21C15 17.134 11.866 14 8 14C4.13401 14 1 17.134 1 21C1 24.866 4.13401 28 8 28Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23L5 21L7 19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30952 21.0672L11.5 21.0672",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 23H24.2998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2998 27H21.2998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSendingback30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xOC4zMDc3IDE4LjkyMzFIMjdDMjguMTA0NiAxOC45MjMxIDI5IDE4LjAyNzYgMjkgMTYuOTIzMVY1QzI5IDMuODk1NDMgMjguMTA0NiAzIDI3IDNIOEM2Ljg5NTQzIDMgNiAzLjg5NTQzIDYgNVYxMC42MTU0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMjEuMDQ3OSAxMS41MzAyTDI4LjExNTMgMTguNDgwOCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTI4LjMyMzggMy41MjE1OEwxOS4wMjMyIDEzLjE4MTVDMTguOTMxMiAxMy4yNzcgMTguODMxNCAxMy4zNjU0IDE4LjcxNjYgMTMuNDMxN0MxNy45NjQ1IDEzLjg2NjUgMTcuMDM2NSAxMy44NjY1IDE2LjI4NDQgMTMuNDMxN0MxNi4xNjk3IDEzLjM2NTQgMTYuMDY5OCAxMy4yNzcgMTUuOTc3OSAxMy4xODE1TDYuNjc2NzYgMy41MjE1OCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDI4QzExLjg2NiAyOCAxNSAyNC44NjYgMTUgMjFDMTUgMTcuMTM0IDExLjg2NiAxNCA4IDE0QzQuMTM0MDEgMTQgMSAxNy4xMzQgMSAyMUMxIDI0Ljg2NiA0LjEzNDAxIDI4IDggMjhaIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNyAyM0w1IDIxTDcgMTkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik01LjMwOTUyIDIxLjA2NzJMMTEuNSAyMS4wNjcyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTguMjk5OCAyM0gyNC4yOTk4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNMTguMjk5OCAyN0gyMS4yOTk4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";